import { withStyles, Switch } from '@material-ui/core';
import Tooltip from '../StyledToolTip';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  switchBase: {
    height: 30,
    color: theme.ToggleDisableIconColor,
    '&$checked': {
      color: theme.ToggleIconColor,
      '& + $track': {
        backgroundColor: theme.ToggleIconColor
      }
    }
  },
  track: {
    backgroundColor: theme.ToggleDisableIconColor
  },
  checked: {},
  label: {
    fontSize: theme.textFontSize,
    lineHeight: '16px',
    color: theme.gridTextColor,
    flex: 1
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1
  }
});

const LabeledToggle = ({
  classes,
  label,
  checked,
  onChange,
  meta = {},
  labelFormatter,
  menuTooltipText = ''
}) => {
  const formattedLabel = labelFormatter ? labelFormatter(label, meta) : label;

  return (
    <div className={classes.container}>
      <Tooltip title={menuTooltipText}>
        <div className={classes.menuItem}>
          <div className={classes.label}>{formattedLabel}</div>
          <div>
            <Switch
              checked={checked}
              onChange={(e, newChecked) => onChange?.(newChecked, meta)}
              classes={{
                switchBase: classes.switchBase,
                checked: classes.checked,
                bar: classes.track
              }}
            />
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(LabeledToggle);
